import { PDF_COLORS } from "./stylesPDFv2";

/**
 * Layout de las tablas SECUNDARIAS del documento (desgloses, resúmenes,
 * documentos relacionados). Mismo lenguaje visual que la tabla de conceptos
 * —sin rejilla ni zebra, separación por aire y una línea fuerte bajo el
 * encabezado— pero con padding más compacto porque suelen ser tablas cortas
 * que acompañan al bloque principal.
 */
export const dataTableLayoutV2 = {
  fillColor: () => null,
  hLineWidth: (i, node) => {
    if (i === 0) return 0;
    if (i === 1) return 1.5; // bajo el encabezado (fuerte)
    if (i === node.table.body.length) return 0; // pie de la tabla
    return 0.5; // entre renglones
  },
  hLineColor: () => PDF_COLORS.tableDivider,
  vLineWidth: () => 0,
  paddingTop: () => 3,
  paddingBottom: () => 3,
  paddingLeft: () => 4,
  paddingRight: () => 4,
};

/**
 *
 * @param {object} params
 * @param {Array} params.title  fila de encabezado (celdas pdfMake)
 * @param {Array} params.rows   renglones (arrays de celdas)
 * @param {Array<string>} params.widths anchos de columnas
 * @param {Array<number>} params.margin margen del nodo
 * @returns nodo pdfMake (table)
 */
export const PDFDataTableV2 = ({ title, rows = [], widths, margin = [0, 2, 0, 4] } = {}) => ({
  margin,
  table: {
    headerRows: 1,
    widths,
    body: [title, ...rows],
  },
  layout: dataTableLayoutV2,
});

export default PDFDataTableV2;
